import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import SoftBox from "../SoftBox";
import { formatKey } from "utils";
import SoftTypography from "../SoftTypography";
import { DateTimePicker } from "@mui/x-date-pickers";

export default function SoftDateTimePicker({
  value: [key, val] = ["", ""],
  onChange,
  inputFormat = "dd/MM/yyyy p",
  disableDate,
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <SoftBox>
        <SoftBox mb={0.5} ml={0.5}>
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            {key && formatKey(key)}
          </SoftTypography>
        </SoftBox>
        <DateTimePicker
          inputFormat={inputFormat}
          value={val}
          shouldDisableDate={disableDate}
          onChange={(newVal) => onChange(newVal, key)}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={() => {
                return {
                  width: "100%",
                  "& input": {
                    width: "100% !important",
                  },
                };
              }}
            />
          )}
        />
      </SoftBox>
    </LocalizationProvider>
  );
}
